export default __webpack_public_path__ + "static/media/charttest.374f8355.svg";